module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapter-hs"
  }, [_c('span', [_vm._v("PREFACE")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("In real life when one meets a large family, with all its ramifications of uncles, aunts, and cousins, as well as grandfathers and grandmothers, grandchildren, and great-grandchildren, their friends, servants, and pet animals, it takes time to distinguish them; one does not expect to remember straight away that it is Jane who is married to Bertram, Jack who was born with a club foot, Aunt Margaret who had the unfortunate love affair. One has to get to know them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("China Court")]), _vm._v(" is a novel about five generations of a family, so that, as in real life, there are many names and personalities, but I believe if the reader is a little patient – and can bear not to skip – they will soon become distinct and he will have no need to look at the family tree on the frontispiece.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Life, Chaucer says, is a ‘thinne subtil knittinge of thinges’; naturally it is difficult to understand.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_vm._v("R.G.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4968b930","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frantmatter02.vue
// module id = 75
// module chunks = 0